import { ExternalLink } from '@/components/ExternalLink';
import { EXTERNAL_LINKS } from '@/helpers/linkHelpers';

interface RecaptchaTermsProps {
  classes?: {
    wrapper?: string;
    links?: string;
  };
  trackingContext: string;
}

export function RecaptchaTerms({
  classes,
  trackingContext,
}: RecaptchaTermsProps) {
  const defaultClasses = {
    wrapper: 'text-body-300 text-gray-400 mt-2',
    links: 'text-link',
  };

  const componentClasses = {
    ...defaultClasses,
    ...classes,
  };

  return (
    <p className={componentClasses.wrapper}>
      {'This site is protected by reCAPTCHA and Google. '}
      <ExternalLink
        href={EXTERNAL_LINKS.recaptchaPrivacy}
        className={componentClasses.links}
        trackingContext={trackingContext}
      >
        Privacy Policy
      </ExternalLink>
      {' and '}
      <ExternalLink
        href={EXTERNAL_LINKS.recaptchaTerms}
        className={componentClasses.links}
        trackingContext={trackingContext}
      >
        Terms of Service
      </ExternalLink>{' '}
      apply.
    </p>
  );
}
